// 🧱 Build form v2's switch (the SHOW_PORTED_PLACE / placeOn pattern: an
// exported constant, test-pinned, so flipping it is a deliberate two-file
// edit). Tiny and dependency-free on purpose: pages/CustomSpace.js imports it
// eagerly, and the form itself (BuildSpaceV2) loads as its own chunk only
// when the switch says so.
//
// ON since 10-01 (Nina: "Right after" the unlisted leak fixes): every visitor
// to /custom-space gets v2. Today's form stays in CustomSpace.js as the
// fallback when the v2 chunk will not load, and behind ?form=classic (below).
//
// The admin preview (a browser holding the /admin key: ?form=v2 remembers it
// on that device, ?form=v1 forgets it) changes nothing on screen while the
// switch is on. It stays so that turning the switch back off is the whole
// rollback, with Nina's one-device preview still there.
export const SHOW_BUILD_FORM_V2 = true;
export const BUILD_FORM_PREVIEW_KEY = 'build_form_v2_preview';

export function buildFormPreviewOn(win = (typeof window !== 'undefined' ? window : null)) {
  try {
    const ls = win && win.localStorage;
    if (!ls || !ls.getItem('adminApiKey')) return false;
    const q = new URLSearchParams(win.location.search).get('form');
    if (q === 'v2') ls.setItem(BUILD_FORM_PREVIEW_KEY, '1');
    if (q === 'v1') ls.removeItem(BUILD_FORM_PREVIEW_KEY);
    return ls.getItem(BUILD_FORM_PREVIEW_KEY) === '1';
  } catch (e) { return false; }
}

// The preview runs FIRST, so ?form=v1 still forgets a stored preview with the
// switch on (a bare `SHOW || preview` would short-circuit and never read it).
export const buildFormV2On = (win) => buildFormPreviewOn(win) || SHOW_BUILD_FORM_V2;

// 🧰 The classic form, on purpose (Nina 10-01: anyone can still reach today's
// form for its 7 personality dials and a creator name). /custom-space?form=classic
// opens today's form for ANY visitor, no admin key: for that URL only. Nothing
// is stored, and the admin preview key is never read or written for it
// (buildFormPreviewOn acts on 'v2' / 'v1' alone). pages/CustomSpace.js reads it
// LIVE from the URL (BuildSpaceV2's "More options" hops there in-app, and Back
// returns to v2); plain /custom-space, ?form=v2 and ?form=v1 are untouched.
export const CLASSIC_FORM = 'classic';

/** Does this query ask for the classic form? `q` = a search string or URLSearchParams. */
export function classicFormAsked(q) {
  try {
    const p = (q && typeof q.get === 'function') ? q : new URLSearchParams(typeof q === 'string' ? q : '');
    return p.get('form') === CLASSIC_FORM;
  } catch (e) { return false; }
}

/** The classic form's own link, carrying the linked AI (?agentId=) when there is one. */
export function classicFormHref(agentId) {
  return `/custom-space?form=${CLASSIC_FORM}${agentId ? `&agentId=${encodeURIComponent(agentId)}` : ''}`;
}
